<div *ngFor="let seat of seatLayouts ;let seatIdx = index">
  <div *ngIf="seat.occupied">
    <button class="fsp-seat fsp-occupied sprite booked" tabindex="{{seat.index}}" id="seat{{seat.index}}"
      [attr.aria-label]="'label_occupied_seat_accessibility'| translate : {seatNumber: seat.seatNumber} "
      [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? 'fsp-seat fsp-free sprite booked rotateseat' : 'fsp-seat fsp-free sprite booked'"
      (click)="onBookedSeatClick($event,seat.seatNumber)" [style.line-height.px]='seat.height'
      [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
      <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
        {{seat.seatNumber}}</div>
    </button>
  </div>

  <div *ngIf="seat.locked">
    <button class="fsp-seat fsp-locked sprite selected" tabindex="{{seat.index}}" id="seat{{seat.index}}"
      [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? 'fsp-seat fsp-free sprite booked rotateseat' : 'fsp-seat fsp-free sprite booked'"
      (click)="onEmptySeatClick(seat)" [style.line-height.px]='seat.height'
      [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
      <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
        {{seat.seatNumber}}</div>
    </button>
  </div>

  <div *ngIf="seat.isSelected && seat.seatClass !== 'ADA'">
    <button class="fsp-seat fsp-selected sprite selected" tabindex="{{seat.index}}" id="seat{{seat.index}}"
      [attr.aria-label]="'label_selected_seat_accessibility'| translate : {seatNumber: seat.seatNumber} "
      [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? 'fsp-seat fsp-free sprite available rotateseat' : 'fsp-seat fsp-free sprite available'"
      (click)="onEmptySeatClick(seat)" [style.line-height.px]='seat.height'
      [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
      <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
        {{seat.seatNumber}}</div>
    </button>
  </div>

  <div *ngIf="seat.isSelected && seat.seatClass === 'ADA'">
    <button class="fsp-seat fsp-selected sprite ada-selected" (click)="onEmptySeatClick(seat)" tabindex="{{seat.index}}"
      id="seat{{seat.index}}"
      [attr.aria-label]="'label_selected_seat_accessibility'| translate : {seatNumber: seat.seatNumber} "
      [style.line-height.px]='seat.height'
      [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
      <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
        {{seat.seatNumber}}</div>
    </button>
  </div>

  <div
    *ngIf="(seat.isSelected === undefined || !seat.isSelected) && (seat.occupied === undefined || !seat.occupied) && (seat.locked === undefined || !seat.locked)">
    <div *ngIf="seat.seatClass === 'General' && seat.seatStatus.toLowerCase()==='available'">
      <button tabindex="{{seat.index}}" id="seat{{seat.index}}"
        [attr.aria-label]="'label_free_seat_accessibility'| translate : {seatNumber: seat.seatNumber} "
        [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? 'fsp-seat fsp-free sprite available rotateseat' : 'fsp-seat fsp-free sprite available'"
        (click)="onEmptySeatClick(seat)" [style.line-height.px]='seat.height'
        [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
        <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
          {{seat.seatNumber}}</div>
      </button>
    </div>
    <div *ngIf="seat.seatClass === 'General' && seat.seatStatus.toLowerCase()==='blocked'">
      <button tabindex="{{seat.index}}" id="seat{{seat.index}}"
        [attr.aria-label]="'label_free_seat_accessibility'| translate : {seatNumber: seat.seatNumber} "
        [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? 'fsp-seat fsp-free sprite blocked rotateseat' : 'fsp-seat fsp-free sprite blocked'"
        (click)="onEmptySeatClick(seat)" [style.line-height.px]='seat.height'
        [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
        <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
        </div>
      </button>
    </div>

    <div *ngIf="seat.seatClass === 'Conferance Table'">
      <div class="fsp-seat fsp-free conference" [style.line-height.px]='seat.height'
        [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
        <div>
          {{seat.seatNumber}}</div>
      </div>
    </div>

    <div *ngIf="seat.seatClass === 'ADA' && seat.seatStatus?.toLowerCase()==='available'">
      <button class="fsp-seat fsp-free sprite ada" (click)="onEmptySeatClick(seat)"
        [ngClass]="seat.isSelected ? 'selected' : ''" [style.line-height.px]='seat.height' tabindex="{{seat.index}}"
        id="seat{{seat.index}}"
        [attr.aria-label]="'label_free_seat_accessibility'| translate : {seatNumber: seat.seatNumber} "
        [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
        <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
          {{seat.seatNumber}}</div>
      </button>
    </div>
    <div *ngIf="seat.seatClass === 'ADA' && seat.seatStatus.toLowerCase()==='blocked'">
      <button class="fsp-seat fsp-free sprite blocked-ada" (click)="onEmptySeatClick(seat)"
        [ngClass]="seat.isSelected ? 'selected' : ''" [style.line-height.px]='seat.height' tabindex="{{seat.index}}"
        id="seat{{seat.index}}"
        [attr.aria-label]="'label_free_seat_accessibility'| translate : {seatNumber: seat.seatNumber} "
        [ngStyle]="{left: seat.x +'px', top: seat.y +'px',width: seat.width +'px', height: seat.height + 'px'}">
        <div [ngClass]="seat.seatNumber == 7 || seat.seatNumber == 8 || seat.seatNumber == 9 || seat.seatNumber == 10 ? ' rotateseat number-center':'number-center'">
         </div>
      </button>
    </div>
  </div>
</div>
<!-- <p-dialog header="Title" [visible]="displayMessage.length > 0" (visibleChange)="onHide($event);"
    [style]="{width: '300px', height: '200px'}">
    <h2> {{ displayMessage }} </h2>
  </p-dialog> -->